import type { Vector2 } from "./geometry";
import type { MiterSkeletonEdge } from "./MiterSkeletonEdge";

export class MiterSkeletonNode {
  position: Vector2;
  velocity: Vector2;
  readonly incident: MiterSkeletonEdge[];

  constructor(position: Vector2) {
    this.position = { x: position.x, y: position.y };
    this.velocity = { x: 0, y: 0 };
    this.incident = [];
  }

  // Return the incident edge that isn't `exclude` and isn't a
  // degenerate self-loop. Skeleton vertices have at most two
  // non-degenerate incident edges in steady state, so there's at
  // most one "other"; callers use this to find the edge that will
  // be rewired after a collapse event. Self-loops are mapping
  // markers for previously-collapsed edges (their source-edge
  // back-pointers still carry meaning for the output→input map),
  // but they take no further part in event propagation. Returns
  // undefined if no such edge exists.
  otherIncident(exclude: MiterSkeletonEdge): MiterSkeletonEdge | undefined {
    for (const e of this.incident) {
      if (e === exclude) {
        continue;
      }
      if (e.a === e.b) {
        continue;
      }
      return e;
    }
    return undefined;
  }
}
